import React, { useContext, useEffect, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import useRightClickMenu from './hooks/useRightClickMenu';
import ContextMenu from './components/context-menu/ContextMenu';




import Dock from './components/dock/Dock';
import Styles from "./App.module.scss"
import AboutSystem from './components/about-system/AboutSystem';
import Header from './components/header/Header';
import Gallery from './components/gallery/Gallery';
import SystemSettings from './components/settings/SystemSettings';
import AppleBooting from './components/apple-booting/AppleBooting';
import ScreenSaver from './components/screen-saver/ScreenSaver';
import PhotoBooth from './components/photobooth/PhotoBooth';
import AboutMe from './components/about-me/AboutMe';
import AppStore from './components/app-store/AppStore';
import XCode from './components/xcode/XCode';
import Spotify from './components/spotify/Spotify';
import Messages from './components/message/Messages';
import AppleMusic from './components/apple-music/AppleMusic';
import Notes from './components/notes/Notes';
import Contact from './components/contacts/Contact';
import DevSkills from './components/dev-skills/DevSkills';

import handleAppWindow from './reducers/windowState';
import { useSelector, RootStateOrAny, useDispatch } from 'react-redux';
import { APP_KEY_IDS } from './constants/constants';



//Firebase
import { initializeApp } from 'firebase/app';
import { get, getDatabase, ref } from 'firebase/database';
import Safari from './components/safari/Safari';
import Finder from './components/finder/Finder';
import Help from './components/help/Help';
import ActionCenter from './components/mobile/action-center/ActionCenter';
import AppPanel from './components/mobile/app-panel/AppPanel';
import MobileGallery from './components/mobile/mobile-gallery/MobileGallery';
import Skills from './components/mobile/skills/Skills';
import Camera from './components/mobile/camera/Camera';
import MobileCamera from './components/mobile/camera/MobileCamera';
import MobileAboutMe from './components/mobile/about-me/MobileAboutMe';
import MobileSpotify from './components/mobile/mobile-spotify/MobileSpotify';
import GalaxyStore from './components/mobile/galaxy-store/GalaxyStore';
import SamsungBrowser from './components/mobile/samsung-browser/SamsungBrowser';
import SamsungBooting from './components/mobile/samsung-booting/SamsungBooting';
import SamsungCall from './components/mobile/samsung-calling/SamsungCall';
import Feedback from './components/feedback/Feedback';
import Hire from './components/hire/Hire';
import MessageWindow from './components/message/messsage-window/MessageWindow';
import SamsungMessages from './components/mobile/samsun-messages/SamsungMessages';
import Settings from './components/mobile/settings/Settings';
import LockScreen from './components/mobile/lock-screen/LockScreen';
import Weather from './components/weather/Weather';
import Clock from './components/clock/Clock';
import { auth, database, } from './useFirebaseInit';
import firebase from "firebase/app";
import AppContextProvider, { AppContext } from './contexts/AppContext';
import { setNotifications } from './actions/notifications';
import FileExplorer from './components/file-explorer/FileExplorer';
import { AuthContext } from './contexts/AuthContext';
import AuthWindow from './components/auth/AuthWindow';




function App() {

  const dispatch = useDispatch()

  const { userId, isLoggedIn } = useContext(AuthContext)

  const { x, y, showMenu } = useRightClickMenu();

  const appState = useSelector((state: RootStateOrAny) => state.handleAppWindow)
  const isTaskViewEnabled = useSelector((state: RootStateOrAny) => state.handleTaskView)

  const [skills, setSkills] = useState({})
  const [apps, setApps] = useState({})
  const [proficiency, setProficiency] = useState()
  const [desktopWallpapers, setDesktopWallpapers] = useState({})
  const [mobileWallpapers, setMobileWallpapers] = useState({})
  const [desktopScreenSavers, setDesktopScreenSavers] = useState({})
  const [btfApp, setBTFApp] = useState("")
  // const [notifications, setNotifications] = useState({})

  //Firebase init


  const skillsData = ref(database, 'skillset');
  const myAppsData = ref(database, 'myDevs');
  const proficiencyData = ref(database, "proficiency")
  const desktopWallpapersData = ref(database, "wallpapers/desktopWallpapers")
  const mobileWallpapersData = ref(database, "wallpapers/mobileWallpapers")
  const desktopScreensaversData = ref(database, "screensavers")
  const notificationsData = ref(database, "notifications")


  useEffect(() => {

    get(skillsData).then((snapshot) => {
      if (snapshot.exists()) {
        setSkills(snapshot.val())
      }
    }).catch((error) => {
      console.error(error);
    });

    get(myAppsData).then((snapshot) => {
      if (snapshot.exists()) {
        setApps(snapshot.val())
      }
    }).catch((error) => {
      console.log("Some error occured : ", error);
      console.error(error);
    });

    get(proficiencyData).then((snapshot) => {
      if (snapshot.exists()) {
        setProficiency(snapshot.val())
      }
    }).catch((error) => {
      console.log("Some error occured : ", error);
      console.error(error);
    });

    get(desktopWallpapersData).then((snapshot) => {
      if (snapshot.exists()) {
        setDesktopWallpapers(snapshot.val())
      }
    }).catch((error) => {
      console.log("Some error occured : ", error);
      console.error(error);
    });

    get(mobileWallpapersData).then((snapshot) => {
      if (snapshot.exists()) {
        setMobileWallpapers(snapshot.val())
      }
    }).catch((error) => {
      console.log("Some error occured : ", error);
      console.error(error);
    });

    get(desktopScreensaversData).then((snapshot) => {
      if (snapshot.exists()) {
        setDesktopScreenSavers(snapshot.val())
      }
    }).catch((error) => {
      console.log("Some error occured : ", error);
      console.error(error);
    });

    get(notificationsData).then((snapshot) => {
      if (snapshot.exists()) {
        addNotifications(snapshot.val())
      }
    }).catch((error) => {
      console.log("Some error occured : ", error);
      console.error(error);
    });

  }, [])

  const addNotifications = async (data: any) => {
    dispatch(setNotifications(data))
  }

  const ALL_APPS = [
    {
      id: APP_KEY_IDS.FINDER,
      component: <Finder key={APP_KEY_IDS.FINDER} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.HOME,
      component: <FileExplorer key={APP_KEY_IDS.HOME} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.ABOUT_ME,
      component: <AboutMe key={APP_KEY_IDS.ABOUT_ME} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.ABOUT_SYSTEM,
      component: <AboutSystem key={APP_KEY_IDS.ABOUT_SYSTEM} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.APP_STORE,
      component: <AppStore key={APP_KEY_IDS.APP_STORE} apps={apps} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.SAFARI,
      component: <Safari key={APP_KEY_IDS.SAFARI} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.GALLERY,
      component: <Gallery key={APP_KEY_IDS.GALLERY} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.XCODE,
      component: <XCode key={APP_KEY_IDS.XCODE} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.SPOTIFY,
      component: <Spotify key={APP_KEY_IDS.SPOTIFY} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.SETTINGS,
      component: <SystemSettings key={APP_KEY_IDS.SETTINGS} wallpapers={desktopWallpapers} screensavers={desktopScreenSavers} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MESSAGES,
      component: <Messages key={APP_KEY_IDS.MESSAGES} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MUSIC,
      component: <AppleMusic key={APP_KEY_IDS.MUSIC} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.NOTES,
      component: <Notes key={APP_KEY_IDS.NOTES} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.CAMERA,
      component: <PhotoBooth key={APP_KEY_IDS.CAMERA} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.CHROME,
      component: <div key={APP_KEY_IDS.CHROME}></div>,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.DEV_SKILLS,
      component: <DevSkills key={APP_KEY_IDS.DEV_SKILLS} skillsData={skills} proficiency={proficiency} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.CONTACTS,
      component: <Contact key={APP_KEY_IDS.CONTACTS} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.HELP,
      component: <Help key={APP_KEY_IDS.HELP} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_SPOTIFY,
      component: <MobileSpotify key={APP_KEY_IDS.MOBILE_SPOTIFY} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_DEV_SKILLS,
      component: <Skills key={APP_KEY_IDS.MOBILE_DEV_SKILLS} skillsData={skills} proficiency={proficiency} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_GALLERY,
      component: <MobileGallery key={APP_KEY_IDS.MOBILE_GALLERY} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_BIXBY,
      component: <MobileAboutMe key={APP_KEY_IDS.MOBILE_BIXBY} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_CAMERA,
      component: <Camera key={APP_KEY_IDS.MOBILE_CAMERA} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_CONTACTS,
      component: <SamsungCall activeWindow={"contacts"} key={APP_KEY_IDS.MOBILE_CONTACTS} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_PHONE,
      component: <SamsungCall activeWindow={"keypad"} key={APP_KEY_IDS.MOBILE_CONTACTS} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_GALAXY_STORE,
      component: <GalaxyStore key={APP_KEY_IDS.MOBILE_GALAXY_STORE} allApps={apps} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_MAIL,
      component: <div key={APP_KEY_IDS.MOBILE_MAIL}></div>,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_MESSAGES,
      component: <SamsungMessages key={APP_KEY_IDS.MOBILE_MESSAGES} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_MUSIC,
      component: <div key={APP_KEY_IDS.MOBILE_MUSIC}></div>,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_SETTINGS,
      component: <Settings key={APP_KEY_IDS.MOBILE_SETTINGS} wallpapers={mobileWallpapers} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.MOBILE_BROWSER,
      component: <SamsungBrowser key={APP_KEY_IDS.MOBILE_BROWSER} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.FEEDBACK,
      component: <Feedback key={APP_KEY_IDS.FEEDBACK} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.HIRE,
      component: <Hire key={APP_KEY_IDS.HIRE} />,
      zIndex: 1
    },
    {
      id: APP_KEY_IDS.LOCK_SCREEN,
      component: <LockScreen key={APP_KEY_IDS.LOCK_SCREEN} />
    },
    {
      id: APP_KEY_IDS.AUTH,
      component: <AuthWindow key={APP_KEY_IDS.AUTH} />
    },
    {
      id: APP_KEY_IDS.MOBILE_FILE_MANAGER,
      component: <FileExplorer key={APP_KEY_IDS.MOBILE_FILE_MANAGER} />,
      zIndex: 1
    },
  ]

  const handleClick = (clickedId: string) => {
    setBTFApp(clickedId)
  };

  const { isMobile } = useContext(AppContext)

  return (



    <div className={Styles.parent}>
      {/*-------------------------------------------UI Components------------------------------------- */}
      {!isMobile && <ScreenSaver />}


      <div className={Styles.widgets}>
        <Weather />
        <Clock />
      </div>
      {
        ALL_APPS.map((app: any) => {
          if (appState[app.id]) {
            return (
              <div style={app.id === btfApp && app.zIndex ? { position: "relative", zIndex: ALL_APPS.length } : {}} onClick={() => handleClick(app.id)} key={app.id}>
                {app.component}
              </div>
            )
          }
          else {
            return null
          }
        })
      }


      {/*---------------------------------------------------------------------------------------------- */}

      {!isMobile && <ContextMenu x={x} y={y} showMenu={showMenu} />}
      {isMobile && !isTaskViewEnabled && <AppPanel />}
      {!isMobile && <Dock />}
      {isMobile ? <ActionCenter /> : <Header />}


      <a className={Styles.aboutButton} href='#about'>
        About
      </a>
      <section className={Styles.hideSection} id={"about"}>

        <h2>About Priyansh Datyal</h2>
        <p>Hello! I'm Priyansh Datyal, a passionate individual with a strong background in Front-End Development and a keen interest in photography. Currently based in [Your Location], I'm dedicated to creating stunning, user-centric web experiences and capturing moments through my lens.</p>

        <h3>Professional Background</h3>
        <p>With expertise in React and Next.js, I bring a wealth of knowledge in crafting responsive and visually appealing websites. I thrive on staying up-to-date with the latest trends in web development, ensuring that the solutions I provide are not only functional but also cutting-edge.</p>

        <h3>Photography Enthusiast</h3>
        <p>Beyond the world of coding, I'm an avid photographer. I have been capturing moments since I was 10 years old, and my passion for photography has grown alongside my career in tech. Through my lens, I aim to freeze moments in time and tell compelling stories.</p>

        <h3>Mission</h3>
        <p>My mission is to blend creativity with functionality, whether it's through writing elegant code or capturing the perfect shot. I believe in the power of technology to transform ideas into reality and in the magic of photography to immortalize emotions.</p>

        <h3>Let's Connect</h3>
        <p>I'm always open to new opportunities, collaborations, and exciting projects. Whether you're looking for a skilled developer or someone to capture memorable moments, let's connect and explore the possibilities.</p>

        <p>Feel free to explore my portfolio and get in touch for any inquiries or collaborations.</p>

        <p>Thank you for visiting!</p>
      </section >
    </div >

  );
}

export default App;
